import { Link } from 'react-router-dom';

export function Footer() {
  const cities = [
    { name: 'Bordeaux', path: '/bordeaux' },
    { name: 'Mérignac', path: '/merignac' },
    { name: 'Pessac', path: '/pessac' },
    { name: 'Talence', path: '/talence' },
    { name: 'Arcachon', path: '/arcachon' },
    { name: 'Libourne', path: '/libourne' },
    { name: 'Bègles', path: '/begles' },
    { name: 'Cenon', path: '/cenon' },
    { name: 'Gradignan', path: '/gradignan' },
    { name: 'Le Bouscat', path: '/le-bouscat' }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-window-line text-2xl text-teal-400"></i>
              </div>
              <span className="text-lg font-bold">FenetrePro</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Expert en réparation de fenêtres et baies vitrées en Gironde depuis plus de 15 ans.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-8 h-8 bg-gray-700 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-gray-700 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-gray-700 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Services</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#services" className="hover:text-teal-400 transition-colors cursor-pointer">Fenêtres PVC</a></li>
              <li><a href="#services" className="hover:text-teal-400 transition-colors cursor-pointer">Fenêtres Aluminium</a></li>
              <li><a href="#services" className="hover:text-teal-400 transition-colors cursor-pointer">Fenêtres Bois</a></li>
              <li><a href="#window-types" className="hover:text-teal-400 transition-colors cursor-pointer">Baies Vitrées</a></li>
              <li><a href="#window-types" className="hover:text-teal-400 transition-colors cursor-pointer">Volets Roulants</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Villes principales</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              {cities.map((city) => (
                <li key={city.path}>
                  <Link to={city.path} className="hover:text-teal-400 transition-colors cursor-pointer">
                    {city.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Contact</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start">
                <i className="ri-phone-line text-teal-400 mr-2 mt-0.5"></i>
                <a href="tel:+33554542545" className="hover:text-teal-400 transition-colors cursor-pointer">
                  05 54 54 25 45
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-teal-400 mr-2 mt-0.5"></i>
                <a href="mailto:contact@fenetrepro.fr" className="hover:text-teal-400 transition-colors cursor-pointer">
                  contact@fenetrepro.fr
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-teal-400 mr-2 mt-0.5"></i>
                <span>Gironde, Nouvelle-Aquitaine</span>
              </li>
              <li className="pt-2">
                <a 
                  href="https://wa.me/33554542545" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-green-400 hover:text-green-300 transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2 text-lg"></i>
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>&copy; 2024 FenetrePro Gironde. Tous droits réservés.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Mentions légales</a>
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Politique de confidentialité</a>
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">CGV</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}